// export default () => ({
// })

export default () => ({
    subsidiaries: [],
    subsidiariesSelectable: [],
    subsidiarySelect: null,
    subsidiariesPaginatedData: null,
    subsidiary: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})